import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { ShowMoreBlock } from '../';

/* eslint-disable */
export const CurrentQuestions = styled.div`
  padding: 12px 30px 30px;
  border-radius: ${({ theme }) => ` 0 0 ${theme.borderRadius} ${theme.borderRadius}`};
  box-shadow: ${({ theme }) => theme.boxShadow};
  background: #fff;

  ${/*sc-sel*/ ShowMoreBlock} {
    margin-top: 12px;
  }

  ${maxMediaQueries.phablet`
    padding-left: 24px;
    padding-right: 24px;
    margin-left: -24px;
    margin-right: -24px;
  `};

  ${maxMediaQueries.phone`
    padding-left: 15px;
    padding-right: 15px;
    margin-left: -15px;
    margin-right: -15px;
  `};
`;
/* eslint-enable */
